import ImageGallery from "./image-gallery/src/imageGallery";
import TextCollapse from "./text-collapse/src/textCollapse";
import HotelConditions from "./hotel-conditions/src/hotelConditions";
import DistancesCard from "./distances-card/src/distancesCard";
import RatingSummary from "./rating-summary/src/ratingSummary";
import HotelRatingSummary from "./hotel-rating-summary/src/hotelRatingSummary";
import TabsMenu from "./tabs-menu/src/tabsMenu";
import UserReview from "./user-review/src/userReview";
import ScrollingWrapper from "./scrolling-wrapper/src/scrollingWrapper";
import HotelNewWithoutOpinions from "./hotel-new-without-opinions/src/hotelNewWithoutOpinions";
import HotelTypeServiceSection from "./hotel-type-service-section/src/hotelTypeServiceSection";
import HotelGroupServiceCard from "./hotel-group-service-card/src/hotelGroupServiceCard";
import Breadcrumbs from "./breadcrumbs/src/breadcrumbs";
import AlertMessages from "./alert-messages/src/alertMessages";
import RoundedList from "./rounded-list/src/roundedList";
import InfoSummary from "./info-summary/src/infoSummary";
import MenuSticky from "./menu-sticky/src/menuSticky";
import CustomSlider from "./custom-slider/src/customSlider";
import GalleryModal from "./gallery-modal/src/galleryModal";
import ImageGalleryList from "./image-gallery-list/src/imageGalleryList";
import HotelInfoWindow from "./hotel-info-window/src/hotelInfoWindow";
import CardMedia from "./card-media/src/cardMedia";
import HotelRoomCard from "./hotel-room-card/src/hotelRoomCard";
import HotelHighlightedServiceCard from "./hotel-highlighted-service-card/src/hotelHighlightedServiceCard";
import FaqCard from "./faq-card/src/faqCard";
import TripadvisorRatingSummary from "./tripadvisor-rating-summary/src/tripadvisorRatingSummary";
import CustomNotification from "./notification/src/customNotification";

customElements.define('image-gallery', ImageGallery);
customElements.define('text-collapse', TextCollapse);
customElements.define('hotel-conditions', HotelConditions);
customElements.define('distances-card', DistancesCard);
customElements.define('rating-summary', RatingSummary);
customElements.define('hotel-rating-summary', HotelRatingSummary);
customElements.define('tabs-menu', TabsMenu);
customElements.define('user-review', UserReview);
customElements.define('scrolling-wrapper', ScrollingWrapper);
customElements.define('hotel-new-without-opinions', HotelNewWithoutOpinions);
customElements.define('hotel-type-service-section', HotelTypeServiceSection);
customElements.define('hotel-group-service-card', HotelGroupServiceCard);
customElements.define('vpt-breadcrumbs', Breadcrumbs);
customElements.define('alert-messages', AlertMessages);
customElements.define('rounded-list', RoundedList);
customElements.define('info-summary', InfoSummary);
customElements.define('menu-sticky', MenuSticky);
customElements.define('custom-slider', CustomSlider);
customElements.define('gallery-modal', GalleryModal);
customElements.define('image-gallery-list', ImageGalleryList);
customElements.define('hotel-info-window', HotelInfoWindow);
customElements.define('card-media', CardMedia);
customElements.define('hotel-room-card', HotelRoomCard);
customElements.define('hotel-highlighted-service-card', HotelHighlightedServiceCard);
customElements.define('faq-card', FaqCard);
customElements.define('tripadvisor-rating-summary', TripadvisorRatingSummary);
customElements.define('custom-notification', CustomNotification);
